// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"f780ee58","96":"9161b908","172":"5debfb6e","174":"bcf16461","191":"910755cb","261":"ce404c55","338":"7e714d97","339":"b2d0a45b","453":"f0147498","460":"bae9b770","490":"c65a6031","609":"42d67f20","642":"492010a9","684":"7f3526e6","846":"11584894","966":"6d3f3f4a"}[chunkId] + ".chunk.js";
};